import { Component, Input, OnInit, inject } from '@angular/core';
import { Client } from 'app/core/models/client.model';
import { AuthenticationService } from 'app/core/services/authentication.service';

import { RouterLink } from '@angular/router';
import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';

@Component({
    selector: 'app-client-name',
    templateUrl: './client-name.component.html',
    styleUrls: ['./client-name.component.scss'],
    imports: [RouterLink, CopyToClipboardComponent]
})
export class ClientNameComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() client: Client;

  canViewClient = false;

  ngOnInit() {
    this.canViewClient = this.authService.isCaptureAdminUser;
  }
}
